<template>
    <div class="tep-home-view">
        <div class="tep-home-view_image"></div>
    </div>
</template>
<script>
export default {
    name: 'tep-home-view',
}
</script>
<script setup>

</script>

<style scoped>
    .tep-home-view {
        padding: 16px 24px;
        max-height: calc(100vh - 135px);
        height: 100%;
    }
    .tep-home-view_image {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        overflow: hidden;
        width: 100%;
        background-image: url('@/assets/tep-home.jpg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 16px;
        opacity: .85;
    }
</style>
